import { useEffect, useRef } from 'react';

import { message } from 'antd';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { divisionsSelect } from '@src/packages/divisions/redux/actions/selector';
import { ALLOWED_ROLES } from '@src/packages/utils/access';
import useGetDivisionsAllowed from '@src/packages/utils/hooks/useGetDivisionsAllowed';

import { parseReportUrlFilters, resolveReportUrlDivisions } from '../utils/reportUrl';

export const useReportUrlFilters = (entity: 'schedules' | 'templates' | 'routes' | 'operations') => {
  const location = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { allowedDivsIds, permissionsLoaded } = useGetDivisionsAllowed(
    ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.REPORTS.LIST,
  );
  const initial = useRef(parseReportUrlFilters(location.search, entity)).current;
  const applied = useRef(false);
  useEffect(() => {
    if (!initial || applied.current || !permissionsLoaded) return;
    applied.current = true;
    if (initial.divisionIds) {
      const scope = resolveReportUrlDivisions(initial.divisionIds, allowedDivsIds);
      dispatch(divisionsSelect(scope.ids));
      if (scope.rejected) message.warning(intl.formatMessage({ id: 'dashboards.reportUrl.divisionsRejected' }));
    }
  }, [allowedDivsIds, dispatch, initial, intl, permissionsLoaded]);
  return initial;
};
